"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageSection = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const constants_1 = require("../../../../constants");
const PageSectionHeader_1 = require("../PageSectionHeader");
require("./types");
const PageSection = (_a) => {
    var { children, title, description, loading, bodyLoading } = _a, restProps = __rest(_a, ["children", "title", "description", "loading", "bodyLoading"]);
    return (react_1.default.createElement(components_1.StackView, Object.assign({ root: true }, restProps, { direction: components_1.STACK_DIRECTION.column, distribution: components_1.STACK_DISTRIBUTION.lastFill, gap: components_1.STACK_GAP.l }),
        react_1.default.createElement(PageSectionHeader_1.PageSectionHeader, { title: title, description: description }),
        loading ? (react_1.default.createElement(components_1.StackView, { align: components_1.STACK_ALIGN.center, distribution: components_1.STACK_DISTRIBUTION.center },
            react_1.default.createElement(components_1.Spinner, { size: constants_1.SPINNER_SIZES.xxl }))) : (children),
        !loading && bodyLoading && (react_1.default.createElement(components_1.Overlay, { view: components_1.OVERLAY_VIEW.ghost, contentMod: components_1.OVERLAY_CONTENT_MOD.center },
            react_1.default.createElement(components_1.Spinner, { size: constants_1.SPINNER_SIZES.xxl })))));
};
exports.PageSection = PageSection;
exports.PageSection.displayName = 'PageSection';
//# sourceMappingURL=PageSection.js.map